const visileColumns = [
  {
    title: "HR Control",
    field: "HrControl",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },
  {
    title: "Employee Name",
    field: "EmployeeName",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },


  // {
  //   title: "Department",
  //   field: "Department",
  //   locked: false,
  //   filter: "text",
  //   width: 350,
  //   show: true,
  // },
  {
    title: "Performance Eval Activity",
    field: "Activity_Status",
    locked: false,
    filter: "text",
    width: 400,
    show: true,
    activity_status: true,
    editor: "activity_status"
  },
  {
    title: "Work Plan Activity",
    field: "work_plan_activity_status",
    locked: false,
    filter: "text",
    width: 350,
    show: true,
    activity_status: true,
    editor: "activity_status"
  },
  {
    title: "Days Remaining",
    field: "days_remaining",
    locked: false,
    filter: "text",
    width: 200,
    show: true,
  },

  {
    title: "DEPT Code",
    field: "dpdv",
    locked: false,
    filter: "text",
    width: 150,
    show: true,
  },
  {
    title: "PE Status",
    field: "ApprovalStatus",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  {
    title: "Overall Rating",
    field: "OverallPerformanceRating",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },

  {
    title: "Employee ID",
    field: "EmployeeID",
    locked: false,
    filter: "numeric",
    className: "text-end",
    headerClassName: "number-align",
    width: 160,
    show: true,
  },

  {
    title: "Last Updated",
    field: "Last_Updated_Date",
    locked: false,
    filter: "text",
    width: 160,
    show: true,
  },
  {
    title: "Rating Period From",
    field: "RatingPeriodFrom",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 140,
    show: true,
  },
  {
    title: "Rating Period To",
    field: "RatingPeriodTo",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 140,
    show: true,
  },
  {
    title: "Supervision Period From",
    field: "SupervisionPeriodFrom",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 250,
    show: true,
  },
  {
    title: "Supervison Period To",
    field: "SupervisonPeriodTo",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 250,
    show: true,
  },
  {
    title: "Employee Status",
    field: "EmployeeStatus",
    locked: false,
    filter: "text",
    width: 250,
    show: true,
  },
  {
    title: "Increment Status",
    field: "IncrementStatus",
    locked: false,
    filter: "text",
    width: 250,
    show: true,
  },

];

export default visileColumns;
